module.exports = __webpack_public_path__ + "media/images/2-119eacc9e8f328735b8525303972b639.jpg";